import { render, staticRenderFns } from "./city-child-add2.vue?vue&type=template&id=7858ea04&scoped=true&"
import script from "./city-child-add2.vue?vue&type=script&lang=js&"
export * from "./city-child-add2.vue?vue&type=script&lang=js&"
import style0 from "./city-child-add2.vue?vue&type=style&index=0&id=7858ea04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7858ea04",
  null
  
)

export default component.exports